import React, { useState } from "react";
import Modal from "react-bootstrap/Modal";
import axios from "axios";
import { Dimmer } from "../../../spinner";
import { Mensaje } from "../../../mensajes2";
import useTable from "../../../useTableR";
import { SearchInput } from "../../../../ui/inputs/Input";

const CatalogoSolvencia = (props) => {
  const op = require("../../../../modulos/datos");
  const token = localStorage.getItem("jwtToken");
  const [loading, setLoading] = useState(false);
  const [records, setRecords] = useState([]);
  const [itemSelect, setItemSelect] = useState({
    index: -1,
    item: "",
  });
  const [mensaje, setMensaje] = useState({
    mostrar: false,
    titulo: "",
    texto: "",
    icono: "",
  });
  const [filterFn, setFilterFn] = useState({
    fn: (items) => {
      return items;
    },
  });
  const headCells = [
    {
      id: "1",
      label: "N° Solvencia",
      textAlign: "center",
      backgroundColor: "rgba(5, 81, 130, 1)",
      fontSize: "10px",
      color: "white",
    },
    {
      id: "2",
      label: "N° Contribuyente",
      textAlign: "center",
      backgroundColor: "rgba(5, 81, 130, 1)",
      fontSize: "10px",
      color: "white",
    },
    {
      id: "3",
      label: "Cedula",
      textAlign: "center",
      backgroundColor: "rgba(5, 81, 130, 1)",
      fontSize: "10px",
      color: "white",
    },
    {
      id: "4",
      label: "Nombre",
      textAlign: "center",
      backgroundColor: "rgba(5, 81, 130, 1)",
      fontSize: "10px",
      color: "white",
    },
    {
      id: "5",
      label: "Dirección",
      textAlign: "center",
      backgroundColor: "rgba(5, 81, 130, 1)",
      fontSize: "10px",
      color: "white",
    },
    {
      id: "6",
      label: "Dirigido",
      textAlign: "center",
      backgroundColor: "rgba(5, 81, 130, 1)",
      fontSize: "10px",
      color: "white",
    },
  ];
  const buscarSolvencia = async () => {
    setLoading(true);
    const campos = `idsolvencia, idcontribuyente, nombre, cedularif, direccion, fechaemision, dirigido`;
    const tabla = `solvencia`;
    const condi = `1=1`;
    const orden = "idsolvencia desc";
    const endpoint = `${op.conexion}/api/consulta/selecionarregistrocondi?campos=${campos}&nomtab=${tabla}&condi=${condi}&orden=${orden}`;
    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
          "Content-Type": "application/json",
        },
      })
      .then((res) => {
        if (res.status === 200 && res.data.length > 0) {
          setRecords(res.data);
          setDisabled(false);
        } else {
          setMensaje({
            mostrar: true,
            titulo: "",
            texto: "No Existen registros",
            icono: "informacion",
          });
          setDisabled(true);
        }
      })
      .catch((res) => {
        setMensaje({
          mostrar: true,
          titulo: "ERROR",
          texto: "Error al Buscar la Solvencia",
          icono: "error",
        });
      })
      .finally(() => {
        setLoading(false);
      });
  };
  const { TblContainer, TblHead, TblPagination, recordsAfterPagingAndSorting } =
    useTable(records, headCells, filterFn);
  const handleSearch = (e) => {
    let target = e.target;
    setFilterFn({
      fn: (items) => {
        if (target.value === "") {
          return items;
        } else {
          return items.filter((x) => {
            if (
              x.idsolvencia.includes(target.value) ||
              x.idcontribuyente
                .toLowerCase()
                .includes(target.value.toLowerCase()) ||
              x.nombre.toLowerCase().includes(target.value.toLowerCase())
            ) {
              return x;
            }
          });
        }
      },
    });
  };
  const seleccionarRegistro = () => {
    try {
      if (itemSelect.item === "") {
        setMensaje({
          mostrar: true,
          titulo: "ERROR",
          texto: "Error al Seleccionar Registro",
          icono: "error",
        });
        return;
      }
      const { item } = itemSelect;
      props.seleccionarRegistro({
        codigoSolve: item.idsolvencia,
        codigoContri: item.idcontribuyente,
        fecha: new Date(item.fechaemision).toISOString().split("T")[0],
        cedula: item.cedularif,
        nombre: item.nombre,
        direccion: item.direccion,
        organismo: item.dirigido,
      });
      cerrar();
    } catch (error) {
      setMensaje({
        mostrar: true,
        titulo: "ERROR",
        texto: "Error al Seleccionar Registro",
        icono: "error",
      });
    }
  };
  const blanquear = () => {
    setLoading(false);
    setRecords([]);
    setItemSelect({
      index: -1,
      item: "",
    });
    setMensaje({
      mostrar: false,
      titulo: "",
      texto: "",
      icono: "",
    });
  };
  const cerrar = () => {
    props.hidden();
  };
  return (
    <Modal
      {...props}
      aria-labelledby="contained-modal-title-vcenter"
      size="xl"
      contentClassName="p-0 m-0"
      centered
      backdrop="static"
      keyboard={false}
      onShow={() => {
        blanquear();
        buscarSolvencia();
      }}
    >
      <Modal.Header className="azulGradiant text-uppercase">
        <h3 className="fw-bold text-light m-0">Solvencias</h3>
        <button className="btn btn-sm bg-light" onClick={() => cerrar()}>
          <i className="fa fa-times"></i>
        </button>
      </Modal.Header>
      <Modal.Body className="d-flex justify-content-between row">
        <div className="col-md-12 m-0">
          <div className="input-group input-group-sm mb-3 m-0 col-md-5">
            <input
              type="text"
              onChange={handleSearch}
              className="form-control rounded-pill search-input"
              placeholder="Buscar Solvencia..."
            />
          </div>
        </div>
        <div className="col-md-12" style={{ margin: "auto" }}>
          <TblContainer>
            <TblHead />
            <tbody>
              {records &&
                recordsAfterPagingAndSorting().map((item, index) => (
                  <tr
                    key={index}
                    style={{
                      padding: 0,
                      background:
                        itemSelect.index === index ? "lightskyblue" : "white",
                    }}
                    onClick={(e) => {
                      setItemSelect({
                        item: item,
                        index: index,
                      });
                    }}
                  >
                    <td
                      className="align-baseline"
                      style={{
                        fontSize: "11px",
                        textAlign: "center",
                        width: "100px",
                      }}
                    >
                      {item.idsolvencia}
                    </td>
                    <td
                      className="align-baseline"
                      style={{
                        fontSize: "11px",
                        textAlign: "center",
                        width: "120px",
                      }}
                    >
                      {item.idcontribuyente}
                    </td>
                    <td
                      className="align-baseline"
                      style={{
                        fontSize: "11px",
                        textAlign: "center",
                        width: "20px",
                      }}
                    >
                      {item.cedularif}
                    </td>
                    <td
                      className="align-baseline"
                      style={{
                        fontSize: "11px",
                        textAlign: "left",
                        width: "auto",
                      }}
                    >
                      {item.nombre}
                    </td>
                    <td
                      className="align-baseline"
                      style={{
                        fontSize: "11px",
                        textAlign: "left",
                        width: "auto",
                      }}
                    >
                      {item.direccion}
                    </td>
                    <td
                      className="align-baseline"
                      style={{
                        fontSize: "11px",
                        textAlign: "left",
                        width: "auto",
                      }}
                    >
                      {item.dirigido}
                    </td>
                  </tr>
                ))}
            </tbody>
          </TblContainer>
          <TblPagination />
        </div>
      </Modal.Body>
      <Modal.Footer className="footer-azulGradiant">
        <button
          onClick={() => seleccionarRegistro()}
          className="btn btn-sm btn-info rounded-pill"
          disabled={itemSelect.item === ""}
        >
          <i className="fas fa-check-circle"> Aceptar</i>
        </button>
        <button
          onClick={() => cerrar()}
          className="btn btn-sm btn-danger rounded-pill"
        >
          <i className="fas fa-window-close"> Cancelar</i>
        </button>
      </Modal.Footer>
      <Dimmer active={loading} inverted />
    </Modal>
  );
};

export default CatalogoSolvencia;
